'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Networks } from 'AdsUI/lib/Constants';
import Small from 'UIComponents/elements/Small';
import UIBreadcrumbs from 'UIComponents/nav/UIBreadcrumbs';
import UIHeader from 'UIComponents/layout/UIHeader';
import UITruncateString from 'UIComponents/text/UITruncateString';
import NetworkIcon from 'AdsUI/components/NetworkIcon';
import CampaignDetailsHeaderControlButtons from 'AdsUI/containers/campaign-details/CampaignDetailsHeaderControlButtons';
import UIAutosizedTextInput from 'UIComponents/input/UIAutosizedTextInput';
import { CampaignStatusTag } from '../campaigns/EntityStatusTag';
import UIButton from 'UIComponents/button/UIButton';

const CampaignName = ({
  canEditCampaignName,
  entity,
  onChangeCampaignName
}) => {
  const [editedName, setEditedName] = useState(entity.name);

  if (!canEditCampaignName) {
    return /*#__PURE__*/_jsx(UITruncateString, {
      matchContentWidth: true,
      className: "display-inline-block",
      children: entity.name
    });
  }

  return /*#__PURE__*/_jsx(UIAutosizedTextInput, {
    value: editedName,
    affordance: true,
    onChange: e => {
      setEditedName(e.target.value);
      onChangeCampaignName(e.target.value);
    }
  });
};

const HeaderTitle = ({
  entity,
  network,
  canEditCampaignName,
  onChangeCampaignName,
  showCampaignManagement,
  onOpenCampaignPanel,
  adAccount
}) => /*#__PURE__*/_jsxs("div", {
  children: [/*#__PURE__*/_jsxs("div", {
    className: "m-bottom-2 align-center",
    children: [/*#__PURE__*/_jsx(NetworkIcon, {
      network: network,
      size: 24,
      className: "m-right-3"
    }), /*#__PURE__*/_jsx(CampaignName, {
      entity: entity,
      canEditCampaignName: canEditCampaignName && entity.manageable,
      onChangeCampaignName: onChangeCampaignName
    }, entity.name)]
  }), /*#__PURE__*/_jsxs("div", {
    className: "m-top-2 align-center",
    children: [/*#__PURE__*/_jsx(CampaignStatusTag, {
      campaignEntity: entity
    }), network !== Networks.LINKEDIN && /*#__PURE__*/_jsx(Small, {
      use: "help",
      children: network === Networks.ADWORDS ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: `adwordsGlobal.campaignType.${entity.type.toLowerCase()}`
      }) : network === Networks.FACEBOOK ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: `facebookGlobal.campaignObjective.${entity.type}`
      }) : null
    }), /*#__PURE__*/_jsxs("div", {
      className: "flex-column m-right-2 m-left-2",
      children: [/*#__PURE__*/_jsx(Small, {
        use: "help",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "campaigns.detailsHeader.adAccount"
        })
      }), /*#__PURE__*/_jsx(Small, {
        children: adAccount.accountName
      })]
    }), showCampaignManagement && /*#__PURE__*/_jsx(UIButton, {
      use: "transparent",
      onClick: onOpenCampaignPanel,
      size: "small",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "campaigns.detailsHeader.viewDetails"
      })
    })]
  })]
});

const CampaignDetailsHeader = props => /*#__PURE__*/_jsx("div", {
  className: "campaign-header-container",
  children: /*#__PURE__*/_jsx(UIHeader, {
    fullWidth: true,
    use: "condensed",
    flush: true,
    className: "m-top-1 p-bottom-2 campaign-header-container",
    title: /*#__PURE__*/_jsx(HeaderTitle, Object.assign({}, props)),
    breadcrumbs: /*#__PURE__*/_jsx(UIBreadcrumbs, {
      children: /*#__PURE__*/_jsx(UIRouterButton, {
        to: "/",
        use: "link",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "campaigns.backToAdCampaigns"
        })
      }, 'paid-campaigns')
    }),
    children: /*#__PURE__*/_jsx(CampaignDetailsHeaderControlButtons, {
      entity: props.entity,
      adAccount: props.adAccount,
      showCampaignManagement: props.showCampaignManagement,
      onEditCampaign: props.onEditCampaign,
      onOpenCampaignPanel: props.onOpenCampaignPanel,
      campaignStatus: props.campaignStatus
    })
  })
});

export default CampaignDetailsHeader;